import React from 'react'
import { css, StyleSheet } from 'aphrodite'

function safeStr(value) {
  if (value == null) return ''
  return String(value)
}

function renderInlineFormatting(text) {
  const nodes = []
  const input = safeStr(text)
  const tokenRegex = /(\*_[^]+?_\*|_\*[^]+?\*_|\*[^*]+\*|_[^_]+_|~[^~]+~|```[^`]+```)/g
  let lastIndex = 0
  let match
  let key = 0

  while ((match = tokenRegex.exec(input)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(<span key={'txt_' + key++}>{input.slice(lastIndex, match.index)}</span>)
    }
    const token = match[0]
    if (token.startsWith('*_') && token.endsWith('_*')) {
      nodes.push(<strong key={'fmt_' + key++}><em>{token.slice(2, -2)}</em></strong>)
    } else if (token.startsWith('_*') && token.endsWith('*_')) {
      nodes.push(<em key={'fmt_' + key++}><strong>{token.slice(2, -2)}</strong></em>)
    } else if (token.startsWith('*') && token.endsWith('*')) {
      const content = token.length > 2 ? token.slice(1, -1) : token
      nodes.push(<strong key={'fmt_' + key++}>{content}</strong>)
    } else if (token.startsWith('_') && token.endsWith('_')) {
      const content = token.length > 2 ? token.slice(1, -1) : token
      nodes.push(<em key={'fmt_' + key++}>{content}</em>)
    } else if (token.startsWith('~') && token.endsWith('~')) {
      const content = token.length > 2 ? token.slice(1, -1) : token
      nodes.push(<span key={'fmt_' + key++} className={css(Styles.strike)}>{content}</span>)
    } else if (token.startsWith('```') && token.endsWith('```')) {
      nodes.push(<code key={'fmt_' + key++} className={css(Styles.code)}>{token.slice(3, -3)}</code>)
    } else {
      nodes.push(<span key={'fmt_' + key++}>{token}</span>)
    }
    lastIndex = tokenRegex.lastIndex
  }

  if (lastIndex < input.length) {
    nodes.push(<span key={'txt_' + key++}>{input.slice(lastIndex)}</span>)
  }
  return nodes
}

function renderLine(line) {
  const raw = safeStr(line)
  const trimmed = raw.trimStart()
  if (trimmed.startsWith('- ')) {
    return (
      <span className={css(Styles.bulletLine)}>
        <span className={css(Styles.bulletGlyph)}>•</span>
        <span className={css(Styles.bulletText)}>{renderInlineFormatting(trimmed.slice(2))}</span>
      </span>
    )
  }
  return renderInlineFormatting(raw)
}

export function formatWhatsappText(text) {
  const input = safeStr(text)
  if (!input) return null
  const lines = input.split('\n')
  return lines.map((line, i) => (
    <span key={'line_' + i} className={css(Styles.lineWrap)}>
      {renderLine(line)}
      {i < lines.length - 1 ? <br /> : null}
    </span>
  ))
}

export function documentMetaFromUrl(url, configuredName) {
  const raw = safeStr(url)
  const safe = raw.split('#')[0].split('?')[0]
  const last = safe.split('/').filter(Boolean).pop() || ''
  let inferredName = ''
  try {
    inferredName = last ? decodeURIComponent(last) : ''
  } catch (e) {
    inferredName = last
  }
  const fileNameRaw = safeStr(configuredName).trim() || inferredName || 'Document.pdf'
  const fileName = fileNameRaw.length <= 60 ? fileNameRaw : fileNameRaw.slice(0, 57) + '...'
  const ext = fileNameRaw.includes('.') ? fileNameRaw.split('.').pop().toLowerCase() : ''
  const extLabel = (ext && ext.length <= 5) ? ext.toUpperCase() : 'PDF'
  return { fileName, extLabel }
}

export function WhatsappDocumentCard(props) {
  const url = safeStr(props.url).trim()
  const doc = documentMetaFromUrl(url, props.fileName)
  return (
    <div className={css(Styles.documentCard)}>
      <div className={css(Styles.documentFileTile)}>{doc.extLabel}</div>
      <div className={css(Styles.documentName)} title={doc.fileName}>{doc.fileName}</div>
    </div>
  )
}

const Styles = StyleSheet.create({
  strike: {
    textDecoration: 'line-through',
  },
  code: {
    backgroundColor: '#d8efd0',
    borderRadius: 3,
    padding: '0 4px',
    fontSize: 12,
    fontFamily: 'monospace',
  },
  bulletLine: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    gap: 6,
  },
  bulletGlyph: {
    fontSize: '1em',
    lineHeight: '1.2em',
    marginTop: 1,
  },
  bulletText: {
    display: 'inline',
  },
  lineWrap: {
    display: 'inline',
  },
  documentCard: {
    margin: '0 0 6px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '6px 8px',
    borderRadius: 6,
    border: '1px solid #d9dee1',
    color: '#111b21',
    backgroundColor: '#f8f9fa',
    overflow: 'hidden',
  },
  documentFileTile: {
    flex: '0 0 auto',
    minWidth: 26,
    height: 18,
    padding: '0 4px',
    borderRadius: 3,
    backgroundColor: '#d93025',
    color: '#ffffff',
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: 0.3,
    lineHeight: '18px',
    textAlign: 'center',
    boxSizing: 'border-box',
  },
  documentName: {
    flex: '1 1 auto',
    minWidth: 0,
    fontSize: 12,
    fontWeight: 500,
    color: '#111b21',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
})
